import {merge, ReplaySubject, Subject} from 'rxjs';
import {delay, mapTo, retryWhen} from 'rxjs/operators';
import {WebsocketConfig, WebsocketSubject} from './observables/WebsocketSubject';
import {ty$} from './tingyun';
import {toUiMsg$} from './ui';
import type {WsStatus} from '@/types';

export const wsUrl$ = new ReplaySubject<string>(1);
export const delay$ = new Subject<number>();

const wsOpening$ = new Subject<void>();
export const wsOpened$ = new Subject<void>();
const wsClosing$ = new Subject<void>();
const wsClosed$ = new Subject<void>();

export const wsStatus$ = merge<WsStatus[]>(
  wsOpening$.pipe(mapTo('Opening')),
  wsOpened$.pipe(mapTo('Opened')),
  wsClosing$.pipe(mapTo('Closing')),
  wsClosed$.pipe(mapTo('Closed'))
);

const config: WebsocketConfig = {
  WebSocketCtor: WebSocket,
  urlObservable: wsUrl$,
  openingObserver: wsOpening$,
  openedObserver: wsOpened$,
  closingObserver: wsClosing$,
  closedObserver: wsClosed$,
  delayObserver: delay$,
  tyObserver: ty$,
};

const ws$ = new WebsocketSubject(config);
export {ws$ as toWsMsg$};
// 重连后自动订阅
export const wsMsg$ = ws$.pipe(retryWhen((errors) => errors.pipe(delay(2000))));

wsMsg$.subscribe();

export interface UNetWorkDelay {
  type: 'network-delay';
  data: {
    delay: number;
  };
}

delay$.subscribe((delay: number) => toUiMsg$.next({type: 'network-delay', data: {delay}}));

export function openWS(url: string) {
  wsUrl$.next(url);
}
